/**
 * Created by heshaochuan on 16/12/23.
 */

export default function(eventId, cityId) {
    // hip
    window._hip = [
        [ '_setPageId', 4010007],
        [ '_setShopType', 55],
        ['_setRequestId', eventId + '|' + cityId]
    ]

    // require('@cortex/hippo');
    require('@dp/hippo');
}



// WEBPACK FOOTER //
// ./src/lib/hip.js